import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useHealthCheck = (isEnable: boolean) =>
  useQuery({
    queryKey: ['healthCheck'],
    queryFn: () =>
      axios('https://ropolo-health-check.darkube.app/health', {
        method: 'GET',
      }),
    select: (data) => data.data,
    enabled: isEnable,
    refetchInterval: 30000,
  });
